/**
 * TechnicalStep Component
 * Step 3: Technical information (optional)
 *
 * @version 2025.1.0
 */

import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import { EpcFormData } from '../../../../../types/epc';
import { TechnicalStepProps } from '../EPCFormWizard.types';

export const TechnicalStep: React.FC<TechnicalStepProps> = ({
  disabled = false,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<EpcFormData>();

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Informe as especificações técnicas do EPC.
      </Typography>

      <Alert severity="info" sx={{ mb: 3 }}>
        Todos os campos desta etapa são opcionais. Você pode pular para a próxima etapa.
      </Alert>

      <Grid container spacing={3}>
        {/* Atenuação */}
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Controller
            name="atenuacao"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Fator de Atenuação"
                fullWidth
                error={Boolean(errors.atenuacao)}
                helperText={errors.atenuacao?.message || 'Ex: Redução de 15 dB'}
                disabled={disabled}
              />
            )}
          />
        </Grid>

        {/* Proporcional */}
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <FormControl fullWidth>
            <InputLabel>Proporcional</InputLabel>
            <Controller
              name="proporcional"
              control={control}
              render={({ field }) => (
                <Select {...field} label="Proporcional" disabled={disabled}>
                  <MenuItem value="">Não especificado</MenuItem>
                  <MenuItem value="Sim">Sim - Redução igual para todos</MenuItem>
                  <MenuItem value="Não">Não - Redução variável</MenuItem>
                </Select>
              )}
            />
            <FormHelperText>A redução é igual para todos os trabalhadores?</FormHelperText>
          </FormControl>
        </Grid>

        {/* Método */}
        <Grid size={12}>
          <Controller
            name="metodo"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Método de Operação"
                fullWidth
                error={Boolean(errors.metodo)}
                helperText={errors.metodo?.message || 'Ex: Automático, Manual'}
                disabled={disabled}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TechnicalStep;
